exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trigger-module-root{margin-right:11px}.trigger-module-root .icon-container{display:block}.trigger-module-root i{box-sizing:border-box;padding:11px;text-align:center;vertical-align:middle;font-size:22px}.trigger-module-root i:before{color:#fffefe}@supports(-webkit-touch-callout: none){.trigger-module-root{margin-right:-5px;margin-top:-5px}}.trigger-module-black i:before{color:#1a1919 !important}", ""]);

// Exports
exports.locals = {
	"root": "trigger-module-root",
	"black": "trigger-module-black"
};